import { gql } from '__generated__'

export const UpdateProcessStatus = gql(/* GraphQL */ `
    mutation UpdateProcessStatus(
        $rosterId: ID!
        $rosterCandidateIds: [ID!]
        $candidateIds: [ID!]
        $processStatus: ProcessStatus!
    ) {
        updateCandidateProcessStatus(
            rosterId: $rosterId
            rosterCandidateIds: $rosterCandidateIds
            candidateIds: $candidateIds
            processStatus: $processStatus
        ) {
            message
            success
        }
    }
`)

export const UpdateProcessStatusAcrossRosters = gql(/* GraphQL */ `
    mutation UpdateProcessStatusAcrossRosters(
        $rosterCandidateIds: [ID!]!
        $processStatus: ProcessStatus!
        $internalNote: String
        $externalNote: String
    ) {
        updateCandidateProcessStatusAcrossRosters(
            rosterCandidateIds: $rosterCandidateIds
            processStatus: $processStatus
            internalNote: $internalNote
            externalNote: $externalNote
        ) {
            message
            success
        }
    }
`)
